import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { COLORS } from 'ideta-library/lib/utils/utils';

export declare type SvgIconType =
  | 'gear-circle'
  | 'gear'
  | 'funnel'
  | 'duplicate'
  | 'trash'
  | 'trash-sortable-bis'
  | 'search'
  | 'clear'
  | 'cancel'
  | 'validate'
  | 'pencil-circle'
  | 'tanuki-advice'
  | 'user-avatar'
  | 'tiny-bot-spinner'
  | 'infos'
  | 'caret-down'
  | 'sidenav-home'
  | 'sidenav-edition'
  | 'sidenav-lexicon'
  | 'sidenav-testing'
  | 'sidenav-publish'
  | 'sidenav-chats'
  | 'sidenav-analytics'
  | 'sidenav-data'
  | 'sidenav-settings'
  | 'sidenav-tooltiparrow'
  | 'navigate'
  | 'updown-arrow'
  | 'tiny-bot'
  | 'conversation-icon'
  | 'trash-circle'
  | 'eye-closed'
  | 'edit-writing'
  | 'send-message'
  | 'carrousel-add'
  | 'editor-icon'
  | 'mapping-component-svg'
  | 'zoom-out'
  | 'file-upload'
  | 'error-exclamation'
  | 'giphy'
  | 'database'
  | 'no-database'
  | 'conv-database'
  | 'bot-database'
  | 'sys-database'
  | 'sandbox'
  | 'web'
  | 'facebook'
  | 'workplace'
  | 'smooch'
  | 'twiliovoice'
  | 'google'
  | 'slack'
  | 'rotate-left'
  | 'rotate-right'
  | 'fit'
  | 'center'
  | 'plus'
  | 'edit-writing-nodetemplatepreview'
  | 'line-black'
  | 'line-bottom-children'
  | 'follow-up'
  | 'user-click'
  | 'close-circle'
  | 'fullscreen'
  | 'eye'
  | 'text-bubble'
  | 'stripe'
  | 'zapier'
  | 'arrow-sup'
  | 'arrow-inf'
  | 'dot'
  | 'user-input'
  | 'move-nodelist'
  | 'duplicate-nodelist'
  | 'delete-nodelist'
  | 'add-nodelist'
  | 'alias-modelconnectbubble'
  | 'bubble-modelconnectbubble'
  | 'address'
  | 'card-payment-bloc'
  | 'trash-usersettingspayment'
  | 'edit-circle'
  | 'remove'
  | 'close-entityvalueitem'
  | 'save'
  | 'logout'
  | 'user-icon-idle'
  | 'user-icon-notif'
  | 'nodeTemplate-button'
  | 'nodeTemplate-quickReplies'
  | 'nodeTemplate-quickRepliesAuto'
  | 'nodeTemplate-text'
  | 'nodeTemplate-code'
  | 'nodeTemplate-redirect'
  | 'nodeTemplate-media'
  | 'nodeTemplate-list'
  | 'nodeTemplate-listAuto'
  | 'nodeTemplate-generic'
  | 'nodeTemplate-carrouselAuto'
  | 'nodeTemplate-receipt'
  | 'nodeTemplate-open-graph'
  | 'nodeTemplate-operations'
  | 'nodeTemplate-stripe'
  | 'nodeTemplate-api'
  | 'nodeTemplate-zapier'
  | 'nodeTemplate-comparisons'
  | 'nodeTemplate-location'
  | 'nodeTemplate-delay'
  | 'nodeTemplate-firebaseRealtime'
  | 'nodeTemplate-firestore'
  | 'dicoValues-image'
  | 'dicoValues-video'
  | 'dicoValues-audio'
  | 'dicoValues-map'
  | 'dicoValues-calendar'
  | 'dicoValues-postback'
  | 'dicoValues-url'
  | 'dicoValues-login'
  | 'dicoValues-call'
  | 'dicoValues-share'
  | 'slider-circle'
  | 'lexicon-plus';

@Component({
  selector: 'app-svg-icon',
  templateUrl: './svg-icon.component.html',
  styleUrls: ['./svg-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SvgIconComponent implements OnInit {
  @Input() icon: SvgIconType;
  @Input() width?: number;
  @Input() height?: number;
  @Input() size?: number;
  @Input() fill?: string;
  @Input() class?: string;
  @Input() viewBox?: string;
  @Input() pathStyle?: any;
  @Input() selected?: boolean;

  constructor() {
    this.fill = 'none';
  }

  ngOnInit(): void {
    this.width = this.width ?? this.size;
    this.height = this.height ?? this.size;
  }

  get pathStyleHtml(): any {
    switch (this.icon) {
      case 'navigate':
        return this.pathStyle || { fill: COLORS.gray7 };
      default:
        return this.pathStyle;
    }
  }

  get fillCircle(): string {
    return this.fill !== 'none' ? this.fill : 'white';
  }
}
